import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { gql } from 'apollo-boost';
import { Mutation, withApollo } from 'react-apollo';
import { Formik } from 'formik';
import CustomerForm from '~/components/customerForm/customerForm';
import { customerValidationSchema } from '../../validation/customer';

export const createCustomerMutation = gql`
  mutation createCustomer(
    $breweryId: Int!
    $name: String!
    $email: String!
    $contactName: String
    $phone: String
    $streetAddress: String
    $streetAddress2: String
    $suburb: String
    $city: String
    $postcode: String
    $country: String
    $birthDate: String
    $fin: String
    $notes: String
  ) {
    createCustomer(
      breweryId: $breweryId
      name: $name
      email: $email
      contactName: $contactName
      phone: $phone
      streetAddress: $streetAddress
      streetAddress2: $streetAddress2
      suburb: $suburb
      postcode: $postcode
      city: $city
      country: $country
      birthDate: $birthDate
      fin: $fin
      notes: $notes
    ) {
      id
      name
    }
  }
`;

export const CustomerCreateForm = ({ brewery, history, client }) => (
  <div className="content">
    <Mutation mutation={createCustomerMutation}>
      {(customerCreate, { error }) => (
        <Formik
          initialValues={{
            country: 'Singapore'
          }}
          validateOnChange={false}
          validateOnBlur={false}
          validationSchema={customerValidationSchema}
          onSubmit={async (values, { setErrors, setSubmitting }) => {
            try {
              const newCustomer = await customerCreate({
                variables: {
                  ...values,
                  breweryId: brewery.id
                }
              });
              history.push(`/customers?new=${newCustomer.data.createCustomer.name}`);
            } catch (err) {
              setErrors({
                unknown: 'An unknown error occured'
              });
              setSubmitting(false);
            }
          }}
          render={CustomerForm}
        />
      )}
    </Mutation>
  </div>
);

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}

export default connect(mapStateToProps)(withRouter(withApollo(CustomerCreateForm)));



// WEBPACK FOOTER //
// ./src/containers/customerCreate/customerCreate.jsx